import { PropertiesStore } from '@hortplus/properties-react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { Fragment, useEffect } from 'react';
import { useStores } from './stores/useStores';

/*
 * The purpose of this component is to be a wrapper around components that need
 * trapping data.
 *
 * It initially loads the insect groups using the authentication props passed in
 * and implements a hook to load data based on changes to the propertiesStore.
 */
function TraplogDataProvider(props) {
  const { traplogStore } = useStores();

  useEffect(() => {
    traplogStore.setBearerToken(props.bearerToken);
    traplogStore.setRefreshBearerToken(props.refreshBearerToken);
    traplogStore.setSelectedDatabase(props.selectedDatabase);
    traplogStore.loadInsectGroups(props.bearerToken, props.refreshBearerToken);
    traplogStore.loadTrapLures(props.bearerToken, props.refreshBearerToken);
    traplogStore.loadMatingDisruptionTies(
      props.bearerToken,
      props.refreshBearerToken
    );
    traplogStore.loadSprayProducts();
  }, [props.bearerToken, props.selectedDatabase]);

  useEffect(() => {
    if (props.propertiesStore.selectedProperty) {
      traplogStore.loadTrappingZones(
        props.bearerToken,
        props.refreshBearerToken,
        props.selectedDatabase,
        props.propertiesStore.selectedPropertyId
      );
    }
  }, [
    props.bearerToken,
    props.selectedDatabase,
    props.propertiesStore.selectedPropertyId
  ]);

  return <Fragment>{props.children}</Fragment>;
}

TraplogDataProvider.propTypes = {
  selectedDatabase: PropTypes.string,
  bearerToken: PropTypes.string.isRequired,
  refreshBearerToken: PropTypes.func.isRequired,
  propertiesStore: PropTypes.instanceOf(PropertiesStore).isRequired
};

export default observer(TraplogDataProvider);
